import React from "react";

import { CSSProvider } from "@perfectserve/css-styles-react";

import "./components.css";

interface NoPermissionProps {
  feature?: string;
  showHomeButton?: boolean;
}

const NoPermission = ({ feature = "this feature" }: NoPermissionProps) => {
  return (
    <CSSProvider>
      <div className="card" style={{ width: "max-content", margin: "0 auto", top: "50px", padding: "1rem" }}>
        <div className="card-body">
          <div className="bold mb-10">You do not have permission to access {feature}.</div>
          <div>Please contact your administrator if you believe you should have access to this functionality.</div>
        </div>
      </div>
    </CSSProvider>
  );
};

export default NoPermission;
